import AbstractDispatcher from 'frontools/abstract/AbstractDispatcher';
import GameAbstract from '../core/GameAbstract';
import Template from 'frontools/data/Template';
import { autobind } from 'frontools/decorators/Autobind';
import { Assets } from '../core/Assets';
import NumberUtils from 'frontools/utils/NumberUtils';
import { GameMode, GameManager } from '../core/GameManager';
import { Bad } from './Bad';
import GameTimer from '../core/components/GameTimer';
import Context from 'frontools/core/Context';

export class Trampopeau extends GameAbstract {

    public static instance      : Trampopeau;

    public static CLICK                     : string                        = 'click';
    public static TAP                       : string                        = 'tap';
    private _levelWrapper                   : PIXI.Container                          = new PIXI.Container;

    private _pintes                         : PIXI.extras.AnimatedSprite;
    private _trampo                         : PIXI.extras.AnimatedSprite;
    private _skin                           : PIXI.Sprite;
    private _trampoContainer                : PIXI.Container;
    private _badsContainer                  : PIXI.Container;
    private _burstsContainer                : PIXI.Container;

    private _buttonsContainer               : PIXI.Container;
    private _buttonRight                    : PIXI.Container;
    private _buttonLeft                     : PIXI.Container;

    private _minMove                        : number            = 0 - 10;
    private _maxMove                        : number;
    private _movingValue                    : number            = this._screenWidth * 0.2;

    private _timeScale                      : number            = 1;
    private _timeProgress                   : number            = 0;
    private _generatedTimeOut               : number;

    constructor() {
        super({
            time: 30,
            results: [
                '0-159', //Bas      
                '160-209', //Moyen
                '210-9999' //Élevé  
            ],
            assets: [
                { name: 'pintes', url: 'sprite/pintes/pintes.json' },      
                { name: 'trampo', url: 'sprite/trampoline/trampo.json' },     
                { name: 'bad1', url: 'sprite/bads/bad1.json', init: false },
                { name: 'bad2', url: 'sprite/bads/bad2.json', init: false },     
                { name: 'bad3', url: 'sprite/bads/bad3.json', init: false },     
                { name: 'skin', url: 'sprite/skin.png' },    
                { name: 'burst', url: 'sprite/burst.png' },    

                { name: 'tramposound1', url: 'audio/tramposounds/tramposound1.mp3' },
                { name: 'tramposound2', url: 'audio/tramposounds/tramposound2.mp3' },
                { name: 'tramposound3', url: 'audio/tramposounds/tramposound3.mp3' },
                { name: 'tramposound4', url: 'audio/tramposounds/tramposound4.mp3' },

                { name: 'skinsound1', url: 'audio/skinsounds/skinsound1.mp3' }, 
                { name: 'skinsound2', url: 'audio/skinsounds/skinsound2.mp3' }, 
                { name: 'skinsound3', url: 'audio/skinsounds/skinsound3.mp3' }, 
                { name: 'skinsound4', url: 'audio/skinsounds/skinsound4.mp3' }, 

                { name: 'walkingsound', url: 'audio/walkingsound.mp3' }, 
            ]
            
        });

        // Pseudo singleton
        Trampopeau.instance = this;


    };


    /*
     * @core override
     * _onPreloadComplete - Called when the preload has been completed
     * 
     */
    protected _onPreloadComplete() {
        super._onPreloadComplete();
        
        this._pintes = Assets.sprites['pintes'];    
        this._pintes.loop = true;
        this._pintes.animationSpeed = .5;  
        this._trampo = Assets.sprites['trampo'];    
        this._trampo.loop = false;
        this._skin = Assets.sprites['skin'];

        this._skin.pivot.x = this._skin.width / 2;    

        this._burstsContainer = new PIXI.Container();
        this._badsContainer = new PIXI.Container();  

        this._trampoContainer = new PIXI.Container();   
        this._trampoContainer.addChild(this._pintes);
        this._trampoContainer.addChild(this._trampo);
        this._trampoContainer.pivot.x = this._trampoContainer.width / 2;    
        this._trampoContainer.scale = new PIXI.Point(0.7, 0.7);

        this._buttonLeft = this.createButton('left');           
        this._buttonRight = this.createButton('right');
        this._buttonsContainer = new PIXI.Container();
        this._buttonsContainer.addChild(this._buttonLeft);
        this._buttonsContainer.addChild(this._buttonRight);

        this._pintes.onFrameChange = function(frame) {
            if (frame === this._pintes.totalFrames-1) this._pintes.gotoAndPlay(2);
        }.bind(this)
        window.addEventListener('keydown', this._onKeyPress);
    };

    /*
     * @core override
     * _prepare - Prepare the game components and then starts the countdown
     * 
     */    
    protected _prepare() {
        this._stage.addChild(this._skin);
        this._stage.addChild(this._burstsContainer);
        this._stage.addChild(this._trampoContainer); 
        this._stage.addChild(this._badsContainer);   
        this._stage.addChild(this._buttonsContainer);       

        // Trigger components positioning
        // Note: This will initialise core game components and start the countdown
        super._prepare(); 
    };

    private _onClick(e) {
        TweenMax.fromTo(e.target, 0.4, {alpha: 0.08},{alpha: 0})  
        this._move(e.target.name);  
    }

    @autobind   
    private _onKeyPress(e) { 
        if (e.keyCode == 37) this._move('left');
        else if (e.keyCode == 39) this._move('right');
    }

    private _move(direction:string) {
        var movingValue = (direction == "left") ? -this._movingValue : this._movingValue; 
        var calculatedValue = this._trampoContainer.x + movingValue;
        
        if (calculatedValue < this._minMove) calculatedValue = this._minMove;
        else if (calculatedValue > this._maxMove) calculatedValue = this._maxMove;

        this._pintes.gotoAndPlay(2);
        if (!Assets.sounds['walkingsound'].playing()) Assets.sounds['walkingsound'].play();   
        
        TweenMax.to(this._trampoContainer, 0.5, {x: calculatedValue, 
            onComplete: function() {
                this._pintes.gotoAndStop(0);    
                Assets.sounds['walkingsound'].stop();    
            }.bind(this)
        }) 
    }

    private createButton(name: string) : PIXI.Container{
        var button = new PIXI.Container();
        button.addChild(this._drawRect(this._screenWidth, this._screenHeight, 0xFFFFFF, 1));  
        button.alpha = 0; 
        button.name = name;
        button.x = (name === "left") ? 0 : this._screenWidth;      
        button.y = 0;
        button.interactive = true;
        button.buttonMode = true;
        button.on(Trampopeau.CLICK, this._onClick, this);
        button.on(Trampopeau.TAP, this._onClick, this);
        return button;  
    }

    private _drawRect(w: number = this._screenWidth, h: number = this._screenHeight, color: number = 0xFFFFFF, alpha: number = 1) {
        let rect = new PIXI.Graphics;
        rect.beginFill(color, alpha);
        rect.drawRect(0, 0, w, h);
        rect.endFill();
        return rect;
    };

    /*
     * @core override
     * _start - Starts the game
     *  
     */
    protected _start() {
        super._start();
        
        TweenMax.to(this, this._gameTimer.time, { _timeScale:2.5, ease: Expo.easeOut });    //Higher the timeScale to reach is, the faster the ennemies falling will be

        this._generateBads();
    };

    /*
     * @core override
     * _onTimerComplete - on game timer complete handler
     * @param {event} e - Event
     * 
     */
    protected _onTimerComplete(e) {
        super._onTimerComplete(e);

        clearTimeout(this._generatedTimeOut);
        window.removeEventListener('keydown', this._onKeyPress);    
    };


    protected _end() {
        super._end();
    }

    private _generateBads() {
        this._createNewBad();
        this._gameTimer.addListener(GameTimer.TIME_CHANGE, function(e) {
            if (e.progress >= 0.95) clearTimeout(this._generatedTimeOut);       // Stop creating bads after a certain time
            this._timeProgress = e.progress;
        }.bind(this))
    }

    @autobind
    private _createNewBad() {
        var bady = new Bad(NumberUtils.random(1, 3));    
        bady.addListener(Bad.HIT_SKIN, this._onHitSkin);     
        bady.addListener(Bad.HIT_TRAMPO, this._onHitTrampo);    
        this._badsContainer.addChild(bady.container);    
        var timeout = 1350 * (1-this._timeProgress);    // 1350 is the default delay when the game start
        if (timeout <= 800) timeout = 800;       // 800 is minimum delay between new bad creation
        this._generatedTimeOut = setTimeout(this._createNewBad, timeout);
    }

    @autobind
    private _onHitTrampo(e) {
        this._gameScore.add(10);
        this._trampo.gotoAndPlay(0);    
        Assets.sounds['tramposound'+NumberUtils.random(1, 4)].play();       
    }

    @autobind
    private _onHitSkin(e) {  
        this._gameScore.remove(3); 
        Assets.sounds['skinsound'+NumberUtils.random(1, 4)].play();
        var scalePoint = new PIXI.Point(1, 1);
        e.bad.sprite.scale = scalePoint;
        this._generateBurst(e.bad.sprite.x,e.bad.sprite.y);
        TweenMax.to(e.bad.sprite.scale, 0.6, {y: 0, x:0.8, delay:1, ease:Expo.easeOut})    
        TweenMax.to(e.bad.sprite, 0.3, {alpha:0, delay: 1, ease:Expo.easeOut,              
            onComplete: function() {        
                this._badsContainer.removeChild(e.bad.container);
            }.bind(this)
        })
    }   

    @autobind
    private _generateBurst(x:number, y:number) {
        var burst = new PIXI.Sprite(Assets.sprites['burst'].texture);
        burst.pivot.x = burst.width / 2;
        burst.pivot.y = burst.height / 2;
        burst.scale.x = 0.6;
        burst.scale.y = 0.6;
        burst.x = x;   
        burst.y = y+20;
        this._burstsContainer.addChild(burst);
        var scalePoint = new PIXI.Point(1, 1);
        burst.scale = scalePoint;
        TweenMax.fromTo(burst.scale, 0.3,{y:0}, {y: 1, delay:1, ease:Expo.easeOut})    
    }

    public getTrampoHitZone() {
        return {
            min: this._trampoContainer.x - 40,
            max : this._trampoContainer.x + 40
        }
    }

    public get screenHeight() : number {
        return this._screenHeight;
    }

    public get badsContainer() : PIXI.Container {
        return this._badsContainer;
    }

    public get screenWidth() : number {
        return this._screenWidth;
    }

    public get timeScale() : number {
        return this._timeScale;
    }

    public get trampoY() : number {
        var trampoOffset = 60;
        return this._trampoContainer.y + trampoOffset;
    }

    public get skinY() : number {
        var skinOffset = 25;
        return this._skin.y + skinOffset;
    }

    /*
     * @core override
     * _resize - Resize handler
     * @param {event} e - Event
     * 
     */
    protected _resize(e?: Event) {
        super._resize(e);

        if (this._gameMode === GameMode.PLAYING || typeof e === 'undefined') {
            this._trampoContainer.y = this._screenHeight - this._trampoContainer.height - 30;   
            this._trampoContainer.x = this._screenWidth / 2; 

            this._skin.y = this._screenHeight - this._skin.height/2;      
            this._skin.x = this._screenWidth / 2;   

            this._maxMove = this._screenWidth + 10;
            
            // Resetting buttons width and height
            (this._buttonLeft.getChildAt(0) as PIXI.Graphics).height = this._screenHeight;
            (this._buttonLeft.getChildAt(0) as PIXI.Graphics).width = this._screenWidth/2;
            (this._buttonRight.getChildAt(0) as PIXI.Graphics).height = this._screenHeight;
            (this._buttonRight.getChildAt(0) as PIXI.Graphics).width = this._screenWidth/2;
            this._buttonRight.x = this._screenWidth/2;
        }
    };

}